// eslint-disable-next-line import/prefer-default-export
export const PAGE_NAME = 'Login';
export const CUSTOM_OKTA_STORAGE_KEY = 'dxp-token-storage';
